/**
 * MAV Wellness Blueprint Quiz
 * Self-contained quiz application for Shopify theme injection
 * Version: 1.0.0
 */

(function() {
  'use strict';

  // ============================================================
  // PRODUCT DATABASE
  // ============================================================
  const PRODUCTS = {
    inflameze_advanced: { name: "Inflameze Advanced", handle: "inflameze-advanced-turmeric-joint", price: 31.99, category: "joint", dosage: "1 capsule with food", time: "morning", why: "High-absorption turmeric + boswellia + bromelain for serious joint comfort." },
    inflameze_ultra: { name: "Inflameze Ultra", handle: "inflameze-ultra-caps-50ct", price: 37.99, category: "joint", dosage: "1 capsule with food", time: "morning", why: "Our maximum-strength formula for joints and muscles." },
    inflameze: { name: "Inflameze", handle: "inflameze-botanical-joint-support", price: 27.99, category: "joint", dosage: "1 capsule with food", time: "morning", why: "Botanical joint comfort support." },
    msm_2000: { name: "MSM 2000mg", handle: "msm-2000mg-joint-health-support", price: 19.99, category: "joint", dosage: "1 tablet", time: "morning", why: "Sulfur-rich support for joint flexibility and recovery." },
    joint_solution_advanced: { name: "Joint Support Advanced", handle: "joint-support-advanced", price: 25.99, category: "joint", dosage: "2 capsules", time: "morning", why: "Glucosamine + hyaluronic acid + MSM for joint lubrication." },
    joint_mobility_stack: { name: "Joint + Mobility Stack", handle: "joint-mobility-stack-inflameze-msm", price: 51.73, category: "joint", dosage: "See individual bottles", time: "morning", why: "Our complete joint support bundle: Inflameze + MSM + Joint Solution." },
    yourheart: { name: "YourHeart Nutrients", handle: "yourheart-nutrients-heart-health", price: 27.99, category: "heart", dosage: "1 capsule", time: "morning", why: "Comprehensive cardiovascular and circulation support." },
    blood_pressure_ultra: { name: "Blood Pressure Ultra", handle: "mt-angel-vitamins-blood-pressure-ultra-support-4-pathway-circulatory-support-60-capsules", price: 31.99, category: "heart", dosage: "2 capsules", time: "morning", why: "4-pathway circulatory support formula." },
    coq10: { name: "CoQ10 100mg", handle: "coq10-100mg-30-caps", price: 25.99, category: "heart", dosage: "1 softgel", time: "morning", why: "Heart energy and cellular antioxidant protection." },
    potassium: { name: "Potassium 99mg", handle: "potassium-99mg-citrate-complex", price: 15.99, category: "heart", dosage: "1 capsule", time: "morning", why: "Electrolyte balance and heart rhythm support." },
    sleepy_sleep: { name: "Sleepy Sleep", handle: "natural-sleep-aid-herbal-support", price: 25.99, category: "sleep", dosage: "2 capsules", time: "evening", why: "Herbal blend for falling asleep naturally." },
    sleep_dots: { name: "Wake/Sleep Dots", handle: "wake-sleep-dots-120-dots", price: 15.99, category: "sleep", dosage: "1 dot dissolved on tongue", time: "evening", why: "Fast-acting low-dose melatonin for gentle sleep onset." },
    melatonin_tr: { name: "Melatonin 3mg Timed Release", handle: "melatonin-3mg-timed-release", price: 19.99, category: "sleep", dosage: "1 tablet", time: "evening", why: "Extended-release melatonin for staying asleep all night." },
    passion_flower: { name: "Passion Flower", handle: "relaxation-supplement-passion-fl", price: 21.99, category: "sleep", dosage: "1 lozenge", time: "evening", why: "Calming herbal lozenge for relaxation and ease." },
    five_htp: { name: "5-HTP", handle: "5-htp", price: 19.99, category: "mood", dosage: "1 capsule", time: "evening", why: "Serotonin pathway support for mood and relaxation." },
    ashwagandha: { name: "Adrenal Support", handle: "adrenal-support-60-vegetarian", price: 25.99, category: "stress", dosage: "1 capsule", time: "morning", why: "Clinically studied adaptogen for stress, energy, and focus." },
    adrenal_support: { name: "Adrenal Support", handle: "adrenal-support-60-vegetarian", price: 29.99, category: "stress", dosage: "1 capsule", time: "morning", why: "Targeted support for adrenal fatigue and burnout recovery." },
    triple_b12: { name: "Triple B-12 Dots", handle: "b12-dots-energy-nervous-support", price: 19.99, category: "energy", dosage: "1 dot dissolved on tongue", time: "morning", why: "Three forms of B-12 for energy — sublingual dots absorb 3x faster than capsules." },
    p5p: { name: "P5P 50mg (Active B6)", handle: "p5p-50mg-vitamin-b6-supplement", price: 15.99, category: "energy", dosage: "1 capsule", time: "morning", why: "Active form of B6 for nerve function and energy metabolism." },
    maximum_male: { name: "Maximum Male Vital Energy", handle: "maximum-male-vital-energy", price: 31.99, category: "men", dosage: "2 capsules", time: "morning", why: "Men's energy and vitality with KSM-66 ashwagandha." },
    dhea: { name: "Pure DHEA 25mg", handle: "pure-dhea-25mg", price: 19.99, category: "hormone", dosage: "1 capsule", time: "morning", why: "Hormone precursor for energy, muscle, and aging support." },
    quercetin_nettle: { name: "Quercetin Nettle+", handle: "natural-allergy-solution-quercetin", price: 35.99, category: "immune", dosage: "2 capsules", time: "morning", why: "Powerful seasonal allergy and immune support." },
    quercetin_zinc: { name: "Quercetin Zinc", handle: "quercetin-zinc", price: 35.99, category: "immune", dosage: "1 capsule", time: "morning", why: "Immune defense with quercetin and zinc." },
    l_lysine: { name: "L-Lysine 500mg", handle: "l-lysine-500mg-immune-collagen", price: 11.99, category: "immune", dosage: "1 capsule", time: "morning", why: "Amino acid for immune function and collagen production." },
    selenium: { name: "Selenium 200mcg", handle: "selenium-200mcg-capsules-high", price: 15.99, category: "immune", dosage: "1 capsule", time: "morning", why: "Thyroid, immune, and antioxidant mineral support." },
    super_enzymes: { name: "Super Enzymes+", handle: "super-enzymes-50-caps", price: 37.99, category: "digestive", dosage: "1 capsule with meals", time: "morning", why: "Comprehensive digestive enzyme blend for better nutrient absorption." },
    para_response: { name: "Para Response", handle: "parasite-cleanse-travel-support", price: 35.99, category: "digestive", dosage: "2 capsules", time: "morning", why: "Herbal intestinal cleanse and gut support." },
    water_away: { name: "Water-Away", handle: "water-away-bloating-fluid-support", price: 19.99, category: "digestive", dosage: "1 capsule", time: "morning", why: "Natural fluid balance and bloating relief." },
    livr_support: { name: "LIV'R Support", handle: "livr-support-liver-detox-cleanse", price: 25.99, category: "liver", dosage: "1 capsule", time: "morning", why: "Milk thistle + curcumin + boldo for liver detox." },
    milk_thistle: { name: "Milk Thistle", handle: "milk-thistle-60-ct-vegetarian", price: 19.99, category: "liver", dosage: "1 capsule", time: "morning", why: "Classic single-herb liver protection." },
    brain_boost: { name: "Brain Advantage", handle: "brain-advantage", price: 61.99, category: "brain", dosage: "2 capsules", time: "morning", why: "Comprehensive cognitive support formula." },
    cognizin: { name: "Brain Advantage", handle: "brain-advantage", price: 61.99, category: "brain", dosage: "1 capsule", time: "morning", why: "Patented brain energy and focus compound." },
    nice_bones: { name: "Nice Bones", handle: "nice-bones-250-tabs", price: 19.99, category: "bone", dosage: "2 capsules", time: "evening", why: "Calcium + magnesium + vitamin D for bone density." },
    strontium: { name: "Strontium Bone Power", handle: "bone-power-strontium", price: 25.99, category: "bone", dosage: "1 capsule on empty stomach", time: "evening", why: "Strontium citrate for bone mineral density." },
    vitamin_d: { name: "Good Vitamin D 2000 IU", handle: "good-vitamin-d-60-caps", price: 17.99, category: "bone", dosage: "1 softgel", time: "morning", why: "Vitamin D3 with bromelain for enhanced absorption." },
    nutrisilk: { name: "NutriSilk", handle: "nutrisilk-hair-skin-nail-support", price: 27.99, category: "beauty", dosage: "1 capsule", time: "morning", why: "Hair, skin, and nail support formula." },
    biotin: { name: "NutriSilk", handle: "nutrisilk-hair-skin-nail-support", price: 27.99, category: "beauty", dosage: "1 capsule", time: "morning", why: "High-potency biotin for hair growth and nail strength." },
    nmn_nr: { name: "NMN + NR Cellular Wellness", handle: "nmn-nr-cellular-wellness-supplement", price: 59.99, category: "longevity", dosage: "2 capsules", time: "morning", why: "NAD+ precursors for mitochondrial and cellular health." },
    urolithin_a: { name: "Urolithin A 500mg", handle: "mt-angel-vitamins-urolithin-a-500mg-cellular-energy-mitochondrial-renewal-60-capsules", price: 79.99, category: "longevity", dosage: "1 capsule", time: "morning", why: "Cellular energy and mitochondrial renewal." },
    prost_tech: { name: "Prost-Tech Plus", handle: "prost-tech-plus-prostate-support", price: 43.99, category: "men", dosage: "2 softgels", time: "morning", why: "Prostate and DHT support for men." },
    mens_multi: { name: "Men's Multi", handle: "mens-multi-vitamin-60-capsules", price: 47.99, category: "multi", dosage: "2 capsules", time: "morning", why: "Complete daily multivitamin for men." },
    mens_50_multi: { name: "Men's 50+ Multi", handle: "mens-50-plus-multivitamin", price: 59.99, category: "multi", dosage: "2 capsules", time: "morning", why: "Age-targeted multivitamin for men over 50." },
    prenatal: { name: "My Prenatal", handle: "my-prenatal-complete-nutrition", price: 45.99, category: "women", dosage: "2 capsules", time: "morning", why: "Prenatal with methylfolate, choline, and DHA." },
    womens_multi: { name: "Women's Multi", handle: "womens-multi-cap-60ct", price: 47.99, category: "multi", dosage: "2 capsules", time: "morning", why: "Complete daily multivitamin for women." },
    womens_50_multi: { name: "Women's 50+ Multi", handle: "womens-50-plus-multivitamin", price: 59.99, category: "multi", dosage: "2 capsules", time: "morning", why: "Age-targeted multivitamin for women over 50." },
  };

  // ============================================================
  // SCORING ENGINE
  // ============================================================
  const GOAL_PRODUCT_MAP = {
    joint_comfort: { primary: ['inflameze_advanced', 'msm_2000', 'joint_solution_advanced'], secondary: ['inflameze_ultra', 'joint_mobility_stack', 'inflameze'] },
    heart_health: { primary: ['yourheart', 'blood_pressure_ultra', 'coq10'], secondary: ['potassium'] },
    sleep: { primary: ['sleepy_sleep', 'melatonin_tr'], secondary: ['sleep_dots', 'five_htp', 'passion_flower'] },
    brain_focus: { primary: ['brain_boost', 'cognizin'], secondary: ['ashwagandha', 'triple_b12'] },
    energy: { primary: ['triple_b12', 'ashwagandha', 'coq10'], secondary: ['p5p', 'adrenal_support'] },
    immune: { primary: ['quercetin_nettle', 'quercetin_zinc'], secondary: ['selenium', 'l_lysine', 'vitamin_d'] },
    bone_health: { primary: ['nice_bones', 'strontium', 'vitamin_d'], secondary: [] },
    stress_mood: { primary: ['ashwagandha', 'five_htp', 'adrenal_support'], secondary: ['passion_flower'] },
    digestive: { primary: ['super_enzymes', 'livr_support'], secondary: ['para_response', 'water_away'] },
    beauty: { primary: ['nutrisilk', 'biotin'], secondary: ['l_lysine', 'selenium'] },
    longevity: { primary: ['nmn_nr', 'urolithin_a'], secondary: ['coq10', 'dhea'] },
    performance: { primary: ['maximum_male', 'dhea', 'ashwagandha'], secondary: ['coq10', 'prost_tech'] }
  };

  const DEEP_DIVE_ADJUSTMENTS = {
    'joint_comfort:severe': { inflameze_ultra: 5 },
    'joint_comfort:athletic': { msm_2000: 5 },
    'joint_comfort:preventive': { joint_solution_advanced: 3 },
    'joint_comfort:occasional': { inflameze_advanced: 3 },
    'heart_health:bp_focus': { blood_pressure_ultra: 5 },
    'heart_health:circulation': { yourheart: 5 },
    'heart_health:preventive': { coq10: 5 },
    'heart_health:maintenance': { yourheart: 3, coq10: 3 },
    'sleep:onset': { sleepy_sleep: 5 },
    'sleep:maintenance': { melatonin_tr: 5 },
    'sleep:racing_mind': { five_htp: 5 },
    'sleep:quality': { passion_flower: 5, sleepy_sleep: 3 },
    'brain_focus:afternoon': { triple_b12: 3, brain_boost: 5 },
    'brain_focus:chronic': { cognizin: 5, brain_boost: 3 },
    'brain_focus:memory': { cognizin: 5 },
    'brain_focus:preventive': { brain_boost: 3 },
    'energy:fatigue': { triple_b12: 5, adrenal_support: 3 },
    'energy:crash': { triple_b12: 5, coq10: 3 },
    'energy:motivation': { ashwagandha: 5, adrenal_support: 3 },
    'energy:athletic': { coq10: 5, triple_b12: 3 },
    'immune:seasonal': { quercetin_nettle: 5 },
    'immune:frequent': { quercetin_zinc: 5, selenium: 3 },
    'immune:recovery': { l_lysine: 5, selenium: 3 },
    'immune:maintenance': { quercetin_zinc: 3, vitamin_d: 3 },
    'bone_health:diagnosed': { strontium: 5, nice_bones: 5 },
    'bone_health:age_related': { nice_bones: 5, vitamin_d: 3 },
    'bone_health:deficiency': { vitamin_d: 5, nice_bones: 3 },
    'bone_health:genetic': { strontium: 5, nice_bones: 3 },
    'stress_mood:anxiety': { five_htp: 5 },
    'stress_mood:irritability': { ashwagandha: 5 },
    'stress_mood:physical': { ashwagandha: 5, passion_flower: 3 },
    'stress_mood:burnout': { adrenal_support: 5, ashwagandha: 3 },
    'digestive:bloating': { super_enzymes: 5 },
    'digestive:motility': { super_enzymes: 3, para_response: 3 },
    'digestive:liver': { livr_support: 5, milk_thistle: 3 },
    'digestive:absorption': { super_enzymes: 5 },
    'beauty:hair': { biotin: 5, nutrisilk: 3 },
    'beauty:nails': { biotin: 5 },
    'beauty:skin': { nutrisilk: 5 },
    'beauty:all': { nutrisilk: 5, biotin: 3 },
    'longevity:cellular': { urolithin_a: 5 },
    'longevity:vitality': { nmn_nr: 5, coq10: 3 },
    'longevity:antioxidant': { coq10: 5, selenium: 3 },
    'longevity:nad_specific': { nmn_nr: 5 },
    'performance:athletic': { coq10: 5, ashwagandha: 3 },
    'performance:libido': { maximum_male: 5, dhea: 3 },
    'performance:prostate': { prost_tech: 10 },
    'performance:stamina': { maximum_male: 5, ashwagandha: 3 }
  };

  const PREGNANCY_EXCLUDE = ['ashwagandha', 'dhea', 'maximum_male', 'prost_tech', 'adrenal_support', 'five_htp', 'para_response', 'livr_support', 'inflameze_advanced', 'inflameze_ultra', 'inflameze', 'water_away', 'strontium', 'nmn_nr', 'urolithin_a', 'milk_thistle', 'blood_pressure_ultra', 'brain_boost', 'cognizin', 'melatonin_tr', 'sleepy_sleep', 'msm_2000', 'sleep_dots'];
  const BREASTFEEDING_SAFE = ['prenatal', 'vitamin_d', 'triple_b12', 'nice_bones', 'biotin', 'l_lysine', 'selenium', 'potassium', 'p5p', 'super_enzymes', 'nutrisilk'];

  function scoreProducts(answers) {
    const scores = {};
    Object.keys(PRODUCTS).forEach(k => { scores[k] = 0; });

    // Layer 1: Goals → Product pools
    (answers.goals || []).forEach(goal => {
      const map = GOAL_PRODUCT_MAP[goal];
      if (!map) return;
      map.primary.forEach(p => { scores[p] = (scores[p] || 0) + 10; });
      map.secondary.forEach(p => { scores[p] = (scores[p] || 0) + 5; });
    });

    // Layer 2: Deep-dive adjustments
    (answers.goals || []).forEach(goal => {
      const detail = answers['deepdive_' + goal];
      if (!detail) return;
      const key = goal + ':' + detail;
      const adj = DEEP_DIVE_ADJUSTMENTS[key];
      if (adj) {
        Object.keys(adj).forEach(p => { scores[p] = (scores[p] || 0) + adj[p]; });
      }
    });

    // Layer 3: Demographics
    const age = answers.age;
    const sex = answers.sex;
    const pregnancy = answers.pregnancy;

    if (age === '50-59' || age === '60+') {
      scores.coq10 = (scores.coq10 || 0) + 3;
      scores.nice_bones = (scores.nice_bones || 0) + 3;
      if (sex === 'male') scores.mens_50_multi = (scores.mens_50_multi || 0) + 8;
      if (sex === 'female') scores.womens_50_multi = (scores.womens_50_multi || 0) + 8;
    }

    if (sex === 'male') {
      scores.prost_tech = (scores.prost_tech || 0) + 0; // eligible
      scores.maximum_male = (scores.maximum_male || 0) + 0; // eligible
    }
    if (sex === 'female' && pregnancy === 'ttc') {
      scores.prenatal = (scores.prenatal || 0) + 15;
    }

    // Layer 4: Nutrient gaps
    const gaps = answers.gaps || [];
    if (gaps.includes('plant_based')) scores.triple_b12 = (scores.triple_b12 || 0) + 15;
    if (gaps.includes('low_sun')) scores.vitamin_d = (scores.vitamin_d || 0) + 15;

    // Layer 5: Exclusions and filtering
    let results = Object.keys(scores)
      .filter(k => scores[k] > 0)
      .map(k => ({ key: k, score: scores[k], ...PRODUCTS[k] }));

    // Gender exclusions
    if (sex === 'female') {
      results = results.filter(r => !['prost_tech', 'maximum_male', 'mens_multi', 'mens_50_multi'].includes(r.key));
    }
    if (sex === 'male') {
      results = results.filter(r => !['prenatal', 'womens_multi', 'womens_50_multi'].includes(r.key));
    }

    // Pregnancy exclusions
    if (pregnancy === 'pregnant') {
      results = results.filter(r => !PREGNANCY_EXCLUDE.includes(r.key));
    }
    if (pregnancy === 'breastfeeding') {
      results = results.filter(r => BREASTFEEDING_SAFE.includes(r.key));
    }

    // Has multi exclusion
    if (gaps.includes('has_multi')) {
      results = results.filter(r => r.category !== 'multi');
    }

    // Sort by score descending
    results.sort((a, b) => b.score - a.score);

    // Beginner cap
    const isBeginner = gaps.includes('beginner');
    const primaryCount = isBeginner ? 2 : 3;

    const primary = results.slice(0, primaryCount);
    const secondary = results.slice(primaryCount, primaryCount + 3);

    return { primary, secondary, allScored: results };
  }

  // ============================================================
  // DEEP DIVE QUESTIONS
  // ============================================================
  const DEEP_DIVE_QUESTIONS = {
    joint_comfort: {
      question: "Which sounds most like you?",
      options: [
        { label: "I'm stiff in the morning but it loosens up", value: "occasional" },
        { label: "I've had to give up activities I love", value: "severe" },
        { label: "Nothing's wrong yet — I'm being proactive", value: "preventive" },
        { label: "I push hard physically and need recovery", value: "athletic" }
      ]
    },
    heart_health: {
      question: "What triggered your heart health focus?",
      options: [
        { label: "My doctor mentioned my blood pressure", value: "bp_focus" },
        { label: "Poor circulation — cold hands, tired legs", value: "circulation" },
        { label: "Family history — I'm being proactive", value: "preventive" },
        { label: "General cardiovascular maintenance as I age", value: "maintenance" }
      ]
    },
    sleep: {
      question: "What does a bad night look like?",
      options: [
        { label: "I stare at the ceiling for an hour", value: "onset" },
        { label: "I fall asleep fine but wake at 3am", value: "maintenance" },
        { label: "My mind won't shut off", value: "racing_mind" },
        { label: "I sleep but wake up feeling unrested", value: "quality" }
      ]
    },
    brain_focus: {
      question: "When does the fog hit?",
      options: [
        { label: "Afternoon — I lose my edge after lunch", value: "afternoon" },
        { label: "All day — thinking through mud", value: "chronic" },
        { label: "I forget things I shouldn't", value: "memory" },
        { label: "I'm sharp now but want to stay that way", value: "preventive" }
      ]
    },
    energy: {
      question: "What's your energy situation?",
      options: [
        { label: "I could sleep 12 hours and still be tired", value: "fatigue" },
        { label: "Fine in the morning, dead by 3pm", value: "crash" },
        { label: "No motivation — everything feels like effort", value: "motivation" },
        { label: "I need fuel for workouts", value: "athletic" }
      ]
    },
    immune: {
      question: "What's your immune challenge?",
      options: [
        { label: "Seasonal allergies wreck me", value: "seasonal" },
        { label: "I get sick more often than I should", value: "frequent" },
        { label: "Bouncing back after getting run down", value: "recovery" },
        { label: "Year-round defense", value: "maintenance" }
      ]
    },
    bone_health: {
      question: "What's driving this?",
      options: [
        { label: "Doctor mentioned bone density concerns", value: "diagnosed" },
        { label: "I'm over 50 and want to stay active", value: "age_related" },
        { label: "I don't get enough calcium or vitamin D", value: "deficiency" },
        { label: "Osteoporosis runs in my family", value: "genetic" }
      ]
    },
    stress_mood: {
      question: "How does stress show up?",
      options: [
        { label: "Racing thoughts I can't turn off", value: "anxiety" },
        { label: "I snap at people I love", value: "irritability" },
        { label: "Physical tension — shoulders, jaw, gut", value: "physical" },
        { label: "Burned out and running on empty", value: "burnout" }
      ]
    },
    digestive: {
      question: "What's going on with your gut?",
      options: [
        { label: "Bloated after every meal", value: "bloating" },
        { label: "Things aren't moving like they should", value: "motility" },
        { label: "I want liver and detox support", value: "liver" },
        { label: "I don't think I'm absorbing nutrients well", value: "absorption" }
      ]
    },
    beauty: {
      question: "What bothers you most?",
      options: [
        { label: "Hair falling out or thinning", value: "hair" },
        { label: "Nails that peel and crack", value: "nails" },
        { label: "Skin losing its bounce", value: "skin" },
        { label: "All of the above", value: "all" }
      ]
    },
    longevity: {
      question: "What does 'aging well' mean to you?",
      options: [
        { label: "Keeping my cells young at the mitochondrial level", value: "cellular" },
        { label: "Having energy and vitality at 70, 80, 90", value: "vitality" },
        { label: "Protecting against oxidative damage", value: "antioxidant" },
        { label: "I've read about NAD+ and want to try it", value: "nad_specific" }
      ]
    },
    performance: {
      question: "What kind of performance?",
      options: [
        { label: "Muscle recovery and endurance", value: "athletic" },
        { label: "Libido and sexual vitality", value: "libido" },
        { label: "Prostate health", value: "prostate", maleOnly: true },
        { label: "Overall physical stamina and drive", value: "stamina" }
      ]
    }
  };

  // ============================================================
  // WELLNESS GOALS OPTIONS
  // ============================================================
  const GOALS_OPTIONS = [
    { label: "My joints ache more than they used to", value: "joint_comfort", icon: "💪" },
    { label: "I worry about my heart and blood pressure", value: "heart_health", icon: "❤️" },
    { label: "I can't fall asleep — or stay asleep", value: "sleep", icon: "😴" },
    { label: "Brain fog is ruining my productivity", value: "brain_focus", icon: "🧠" },
    { label: "I'm exhausted by 2pm every day", value: "energy", icon: "⚡" },
    { label: "I catch every cold that goes around", value: "immune", icon: "🛡️" },
    { label: "I'm losing bone density (or worried about it)", value: "bone_health", icon: "🦴" },
    { label: "Stress is eating me alive", value: "stress_mood", icon: "💆" },
    { label: "My digestion is a mess", value: "digestive", icon: "🌿" },
    { label: "My hair is thinning and my nails are brittle", value: "beauty", icon: "✨" },
    { label: "I want to age on my own terms", value: "longevity", icon: "🔬" },
    { label: "I need more drive — physically and otherwise", value: "performance", icon: "🏋️" }
  ];

  // ============================================================
  // QUIZ STATE & RENDERING
  // ============================================================
  let state = {
    page: 0,
    answers: {},
    results: null
  };

  const SHOP_URL = window.location.origin;
  const KLAVIYO_COMPANY_ID = window.__mav_quiz_klaviyo_id || '';
  const DISCOUNT_API_URL = 'https://api.highlandlabs.life/subscription-delay/quiz-discount';

  function getContainer() {
    return document.getElementById('mav-wellness-quiz');
  }

  function render() {
    const container = getContainer();
    if (!container) return;

    const pages = [
      renderHook,
      renderName,
      renderAge,
      renderSex,
      renderGoals,
      renderDeepDive1,
      renderDeepDive2,
      renderGaps,
      renderEmail,
      renderResults
    ];

    // Skip deep dives if not enough goals
    let pageIndex = state.page;
    if (pageIndex === 5 && (!state.answers.goals || state.answers.goals.length === 0)) {
      state.page = 7;
      pageIndex = 7;
    }
    if (pageIndex === 6 && (!state.answers.goals || state.answers.goals.length < 2)) {
      state.page = 7;
      pageIndex = 7;
    }

    container.innerHTML = '';
    container.className = 'mav-quiz-container';

    if (pageIndex < pages.length) {
      pages[pageIndex]();
    }
  }

  // ============================================================
  // PAGE RENDERERS
  // ============================================================

  function renderHook() {
    const c = getContainer();
    const heroImg = window.__mav_hero_image || '';
    const proofImg = window.__mav_social_proof_image || '';
    c.innerHTML = `
      <div class="mav-quiz-hook">
        <div class="mav-quiz-hook-layout">
          <div class="mav-quiz-hook-left">
            <h1 class="mav-quiz-hook-headline">Most people take supplements they don't need.</h1>
            <p class="mav-quiz-hook-body">We've been making supplements for 53 years. In that time, we've learned that the right 2-3 products beat a cabinet full of wrong ones. Let's find yours.</p>
            <div class="mav-quiz-trust-bar">
              <span>✓ 2 minutes</span>
              <span>✓ Science-backed</span>
              <span>✓ Free</span>
              <span>✓ No spam</span>
            </div>
            <button class="mav-quiz-btn-primary" id="mav-quiz-start">Find My Supplements →</button>
            <a href="/collections" class="mav-quiz-secondary-link">Just browsing? Shop by concern →</a>
          </div>
          <div class="mav-quiz-hook-right">
            ${heroImg ? `<img src="${heroImg}" alt="Your personalized supplement stack" loading="eager" />` : ''}
          </div>
        </div>
        ${proofImg ? `<img src="${proofImg}" alt="12,847 quizzes completed, 53 years of expertise, 4.8 star rating" class="mav-quiz-social-proof-img" loading="eager" />` : ''}
      </div>
    `;
    document.getElementById('mav-quiz-start').addEventListener('click', function() {
      fireKlaviyoEvent('Quiz Started', {});
      state.page = 1;
      render();
    });
  }

  function renderName() {
    const c = getContainer();
    c.innerHTML = `
      <div class="mav-quiz-page">
        ${progressBar(1, 8)}
        <h2 class="mav-quiz-question">What's your first name?</h2>
        <input type="text" class="mav-quiz-input" id="mav-quiz-name" placeholder="Your first name" value="${state.answers.name || ''}" autocomplete="given-name" />
        <button class="mav-quiz-btn-primary" id="mav-quiz-name-next">Continue →</button>
      </div>
    `;
    const input = document.getElementById('mav-quiz-name');
    input.focus();
    input.addEventListener('keypress', function(e) { if (e.key === 'Enter') advance(); });
    document.getElementById('mav-quiz-name-next').addEventListener('click', advance);
    function advance() {
      const val = input.value.trim();
      if (!val) { input.classList.add('mav-quiz-input-error'); return; }
      state.answers.name = val;
      state.page = 2;
      render();
    }
  }

  function renderAge() {
    const c = getContainer();
    const options = ['Under 30', '30-39', '40-49', '50-59', '60+'];
    c.innerHTML = `
      <div class="mav-quiz-page">
        ${progressBar(2, 8)}
        <h2 class="mav-quiz-question">How old are you, ${state.answers.name || ''}?</h2>
        <p class="mav-quiz-nugget">Nutrient needs shift with age — especially after 40 when absorption declines and bone density drops.</p>
        <div class="mav-quiz-options-single">
          ${options.map(o => `<button class="mav-quiz-option-btn" data-value="${o}">${o}</button>`).join('')}
        </div>
      </div>
    `;
    c.querySelectorAll('.mav-quiz-option-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        state.answers.age = this.dataset.value;
        state.page = 3;
        render();
      });
    });
  }

  function renderSex() {
    const c = getContainer();
    const showPregnancy = state.answers.sex === 'female';
    let html = `
      <div class="mav-quiz-page">
        ${progressBar(3, 8)}
        <h2 class="mav-quiz-question">Biological sex?</h2>
        <p class="mav-quiz-why-ask"><span class="mav-quiz-expand-trigger">Why we ask ▾</span><span class="mav-quiz-expand-content" style="display:none;"> Certain supplements aren't safe during pregnancy, and hormonal profiles affect which nutrients your body prioritizes.</span></p>
        <div class="mav-quiz-options-single" id="mav-sex-options">
          <button class="mav-quiz-option-btn ${state.answers.sex === 'female' ? 'selected' : ''}" data-value="female">Female</button>
          <button class="mav-quiz-option-btn ${state.answers.sex === 'male' ? 'selected' : ''}" data-value="male">Male</button>
          <button class="mav-quiz-option-btn ${state.answers.sex === 'other' ? 'selected' : ''}" data-value="other">Prefer not to say</button>
        </div>
        <div id="mav-pregnancy-section" style="display:${showPregnancy ? 'block' : 'none'}; margin-top: 24px;">
          <h3 class="mav-quiz-sub-question">Are you currently pregnant or breastfeeding?</h3>
          <div class="mav-quiz-options-single">
            <button class="mav-quiz-option-btn mav-preg-btn" data-value="pregnant">Pregnant</button>
            <button class="mav-quiz-option-btn mav-preg-btn" data-value="breastfeeding">Breastfeeding</button>
            <button class="mav-quiz-option-btn mav-preg-btn" data-value="ttc">Trying to conceive</button>
            <button class="mav-quiz-option-btn mav-preg-btn" data-value="none">None of these</button>
          </div>
        </div>
        <button class="mav-quiz-btn-primary" id="mav-sex-next" style="display:${state.answers.sex && state.answers.sex !== 'female' ? 'block' : 'none'}; margin-top: 24px;">Continue →</button>
      </div>
    `;
    c.innerHTML = html;

    // Expand why we ask
    c.querySelector('.mav-quiz-expand-trigger').addEventListener('click', function() {
      const content = c.querySelector('.mav-quiz-expand-content');
      content.style.display = content.style.display === 'none' ? 'inline' : 'none';
    });

    // Sex selection
    c.querySelectorAll('#mav-sex-options .mav-quiz-option-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        c.querySelectorAll('#mav-sex-options .mav-quiz-option-btn').forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');
        state.answers.sex = this.dataset.value;
        if (this.dataset.value === 'female') {
          document.getElementById('mav-pregnancy-section').style.display = 'block';
          document.getElementById('mav-sex-next').style.display = 'none';
        } else {
          document.getElementById('mav-pregnancy-section').style.display = 'none';
          document.getElementById('mav-sex-next').style.display = 'block';
          state.answers.pregnancy = null;
        }
      });
    });

    // Pregnancy selection
    c.querySelectorAll('.mav-preg-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        state.answers.pregnancy = this.dataset.value;
        state.page = 4;
        render();
      });
    });

    // Continue for non-female
    document.getElementById('mav-sex-next').addEventListener('click', function() {
      if (!state.answers.sex) return;
      state.page = 4;
      render();
    });
  }

  function renderGoals() {
    const c = getContainer();
    const selected = state.answers.goals || [];
    c.innerHTML = `
      <div class="mav-quiz-page">
        ${progressBar(4, 8)}
        <h2 class="mav-quiz-question">What's your body telling you it needs?</h2>
        <p class="mav-quiz-subtitle">Pick your top 3-5.</p>
        <div class="mav-quiz-options-multi" id="mav-goals-grid">
          ${GOALS_OPTIONS.map(o => `
            <button class="mav-quiz-goal-btn ${selected.includes(o.value) ? 'selected' : ''}" data-value="${o.value}">
              <span class="mav-quiz-goal-icon">${o.icon}</span>
              <span class="mav-quiz-goal-label">${o.label}</span>
            </button>
          `).join('')}
        </div>
        <p class="mav-quiz-goal-count" id="mav-goal-count">${selected.length} selected</p>
        <button class="mav-quiz-btn-primary" id="mav-goals-next" ${selected.length < 1 ? 'disabled' : ''}>Continue →</button>
      </div>
    `;

    c.querySelectorAll('.mav-quiz-goal-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const val = this.dataset.value;
        let goals = state.answers.goals || [];
        if (goals.includes(val)) {
          goals = goals.filter(g => g !== val);
          this.classList.remove('selected');
        } else {
          if (goals.length >= 5) return; // max 5
          goals.push(val);
          this.classList.add('selected');
        }
        state.answers.goals = goals;
        document.getElementById('mav-goal-count').textContent = goals.length + ' selected';
        document.getElementById('mav-goals-next').disabled = goals.length < 1;
      });
    });

    document.getElementById('mav-goals-next').addEventListener('click', function() {
      if ((state.answers.goals || []).length < 1) return;
      state.page = 5;
      render();
    });
  }

  function renderDeepDive1() {
    const goals = state.answers.goals || [];
    if (goals.length === 0) { state.page = 7; render(); return; }
    const goal = goals[0];
    renderDeepDive(goal, 5, 6);
  }

  function renderDeepDive2() {
    const goals = state.answers.goals || [];
    if (goals.length < 2) { state.page = 7; render(); return; }
    const goal = goals[1];
    renderDeepDive(goal, 6, 7);
  }

  function renderDeepDive(goal, currentPage, nextPage) {
    const c = getContainer();
    const dd = DEEP_DIVE_QUESTIONS[goal];
    if (!dd) { state.page = nextPage; render(); return; }

    let options = dd.options;
    // Filter male-only options
    if (state.answers.sex !== 'male') {
      options = options.filter(o => !o.maleOnly);
    }

    const stepNum = currentPage === 5 ? 5 : 6;
    c.innerHTML = `
      <div class="mav-quiz-page">
        ${progressBar(stepNum, 8)}
        <h2 class="mav-quiz-question">${dd.question}</h2>
        <div class="mav-quiz-options-single">
          ${options.map(o => `<button class="mav-quiz-option-btn" data-value="${o.value}">${o.label}</button>`).join('')}
        </div>
      </div>
    `;

    c.querySelectorAll('.mav-quiz-option-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        state.answers['deepdive_' + goal] = this.dataset.value;
        state.page = nextPage;
        render();
      });
    });
  }

  function renderGaps() {
    const c = getContainer();
    const selected = state.answers.gaps || [];
    const options = [
      { label: "I eat mostly plant-based", value: "plant_based" },
      { label: "I rarely get direct sunlight", value: "low_sun" },
      { label: "I take prescription medications", value: "medications" },
      { label: "I've never taken supplements before", value: "beginner" },
      { label: "I already take a daily multivitamin", value: "has_multi" },
      { label: "None of these", value: "none" }
    ];

    c.innerHTML = `
      <div class="mav-quiz-page">
        ${progressBar(7, 8)}
        <h2 class="mav-quiz-question">Quick check — any of these apply, ${state.answers.name || ''}?</h2>
        <p class="mav-quiz-why-ask"><span class="mav-quiz-expand-trigger">Why we ask ▾</span><span class="mav-quiz-expand-content" style="display:none;"> These factors affect which nutrients you might be missing. For example, plant-based eaters are almost always low in B-12, and indoor workers typically need vitamin D.</span></p>
        <div class="mav-quiz-options-multi mav-quiz-gaps-grid">
          ${options.map(o => `
            <button class="mav-quiz-gap-btn ${selected.includes(o.value) ? 'selected' : ''}" data-value="${o.value}">${o.label}</button>
          `).join('')}
        </div>
        <button class="mav-quiz-btn-primary" id="mav-gaps-next">Continue →</button>
      </div>
    `;

    // Expand
    c.querySelector('.mav-quiz-expand-trigger').addEventListener('click', function() {
      const content = c.querySelector('.mav-quiz-expand-content');
      content.style.display = content.style.display === 'none' ? 'inline' : 'none';
    });

    c.querySelectorAll('.mav-quiz-gap-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const val = this.dataset.value;
        let gaps = state.answers.gaps || [];
        if (val === 'none') {
          gaps = ['none'];
          c.querySelectorAll('.mav-quiz-gap-btn').forEach(b => b.classList.remove('selected'));
          this.classList.add('selected');
        } else {
          gaps = gaps.filter(g => g !== 'none');
          if (gaps.includes(val)) {
            gaps = gaps.filter(g => g !== val);
            this.classList.remove('selected');
          } else {
            gaps.push(val);
            this.classList.add('selected');
          }
          c.querySelector('[data-value="none"]').classList.remove('selected');
        }
        state.answers.gaps = gaps;
      });
    });

    document.getElementById('mav-gaps-next').addEventListener('click', function() {
      state.page = 8;
      render();
    });
  }

  function renderEmail() {
    const c = getContainer();
    c.innerHTML = `
      <div class="mav-quiz-page mav-quiz-email-page">
        ${progressBar(8, 8)}
        <h2 class="mav-quiz-question">${state.answers.name || ''}, your Wellness Blueprint is ready.</h2>
        <p class="mav-quiz-subtitle">Enter your email to unlock your personalized results — plus a 15% discount that expires in 48 hours.</p>
        <input type="email" class="mav-quiz-input" id="mav-quiz-email" placeholder="your@email.com" autocomplete="email" />
        <button class="mav-quiz-btn-primary" id="mav-email-next">Show Me My Blueprint →</button>
        <p class="mav-quiz-fine-print">We'll send a copy of your results plus a few follow-up tips. One click to unsubscribe. We respect your inbox.</p>
      </div>
    `;
    const input = document.getElementById('mav-quiz-email');
    input.focus();
    input.addEventListener('keypress', function(e) { if (e.key === 'Enter') submitEmail(); });
    document.getElementById('mav-email-next').addEventListener('click', submitEmail);

    function submitEmail() {
      const email = input.value.trim();
      if (!email || !email.includes('@') || !email.includes('.')) {
        input.classList.add('mav-quiz-input-error');
        return;
      }
      state.answers.email = email;

      // Run scoring engine
      state.results = scoreProducts(state.answers);

      // Fire Klaviyo events
      identifyKlaviyo(email, state.answers);
      fireKlaviyoEvent('Quiz Completed', buildEventPayload());
      logQuizResponse();

      // Request discount code
      requestDiscountCode(email);

      state.page = 9;
      render();
    }
  }

  function renderResults() {
    const c = getContainer();
    const results = state.results;
    if (!results || !results.primary.length) {
      renderDisqualification();
      return;
    }

    const primary = results.primary;
    const secondary = results.secondary;
    const totalPrice = primary.reduce((sum, p) => sum + p.price, 0);
    const bundlePrice = (totalPrice * 0.80).toFixed(2);
    // Subscription removed - no selling plan exists for bundles

    const morningProducts = primary.filter(p => p.time === 'morning');
    const eveningProducts = primary.filter(p => p.time === 'evening');

    c.innerHTML = `
      <div class="mav-quiz-results">
        <div class="mav-quiz-results-header">
          <h1>${state.answers.name}'s Wellness Blueprint</h1>
          <p class="mav-quiz-results-date">Created ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} • Personalized to your answers</p>
        </div>

        <div class="mav-quiz-stack-card">
          <h2>YOUR WELLNESS STACK</h2>
          <div class="mav-quiz-stack-products">
            ${primary.map(p => `
              <div class="mav-quiz-stack-product">
                <img src="${(window.__mav_image_map && window.__mav_image_map[p.handle]) || ''}" alt="${p.name}" onerror="this.src='https://www.mtangelvitamins.com/cdn/shop/files/Mt._Angel_Logo_Copy.png?v=1665171091&width=100'" />
                <span class="mav-quiz-stack-product-name">${p.name}</span>
                <span class="mav-quiz-stack-product-price">$${p.price.toFixed(2)}</span>
              </div>
            `).join('')}
          </div>
          <div class="mav-quiz-stack-pricing">
            <div class="mav-quiz-price-line"><span>Individual total:</span><span class="mav-quiz-price-strike">$${totalPrice.toFixed(2)}</span></div>
            <div class="mav-quiz-price-line mav-quiz-price-highlight"><span>Your Stack Price (20% off):</span><span>$${bundlePrice}</span></div>

          </div>
          <button class="mav-quiz-btn-primary mav-quiz-btn-cart" id="mav-add-stack">ADD STACK TO CART →</button>
        </div>

        <div class="mav-quiz-discount-bar" id="mav-discount-bar">
          <span>⏰ 15% off expires in <span id="mav-countdown">47:59:59</span></span>
          <span>Code: <strong id="mav-discount-code">BLUEPRINT15</strong></span>
        </div>

        <div class="mav-quiz-why-section">
          <h2>Why These?</h2>
          ${primary.map(p => `
            <div class="mav-quiz-why-card">
              <div class="mav-quiz-why-card-left">
                <img src="${(window.__mav_image_map && window.__mav_image_map[p.handle]) || ''}" alt="${p.name}" onerror="this.src='https://www.mtangelvitamins.com/cdn/shop/files/Mt._Angel_Logo_Copy.png?v=1665171091&width=80'" />
              </div>
              <div class="mav-quiz-why-card-right">
                <h3>${p.name}</h3>
                <p class="mav-quiz-why-reason"><strong>For you because:</strong> ${getPersonalizedReason(p, state.answers)}</p>
                <p class="mav-quiz-why-price">$${p.price.toFixed(2)}</p>
                <button class="mav-quiz-btn-secondary mav-add-single" data-handle="${p.handle}">Add to Cart</button>
              </div>
            </div>
          `).join('')}
        </div>

        ${secondary.length > 0 ? `
        <div class="mav-quiz-also-section">
          <h2>Also Consider</h2>
          <div class="mav-quiz-also-grid">
            ${secondary.slice(0, 3).map(p => `
              <div class="mav-quiz-also-card">
                <img src="${(window.__mav_image_map && window.__mav_image_map[p.handle]) || ''}" alt="${p.name}" onerror="this.src='https://www.mtangelvitamins.com/cdn/shop/files/Mt._Angel_Logo_Copy.png?v=1665171091&width=80'" style="width:80px;height:80px;object-fit:contain;margin:0 auto 8px;display:block;" />
                <h4>${p.name}</h4>
                <p>${p.why}</p>
                <p class="mav-quiz-also-price">$${p.price.toFixed(2)}</p>
                <button class="mav-quiz-btn-secondary mav-add-single" data-handle="${p.handle}">Add</button>
              </div>
            `).join('')}
          </div>
        </div>
        ` : ''}

        <div class="mav-quiz-routine-section">
          <h2>Your Daily Routine</h2>
          <div class="mav-quiz-routine-card">
            ${morningProducts.length > 0 ? `
            <div class="mav-quiz-routine-time">
              <span class="mav-quiz-routine-icon">☀️</span>
              <strong>MORNING (with breakfast)</strong>
              <ul>${morningProducts.map(p => `<li>${p.name} — ${p.dosage}</li>`).join('')}</ul>
            </div>
            ` : ''}
            ${eveningProducts.length > 0 ? `
            <div class="mav-quiz-routine-time">
              <span class="mav-quiz-routine-icon">🌙</span>
              <strong>EVENING (before bed)</strong>
              <ul>${eveningProducts.map(p => `<li>${p.name} — ${p.dosage}</li>`).join('')}</ul>
            </div>
            ` : ''}
          </div>
        </div>

        <div class="mav-quiz-trust-section">
          <h2>Why Mt. Angel Vitamins?</h2>
          <div class="mav-quiz-trust-grid">
            <div class="mav-quiz-trust-item">🏭 Made in our own facility in Mt. Angel, Oregon</div>
            <div class="mav-quiz-trust-item">🔬 Every batch third-party tested — CoA available</div>
            <div class="mav-quiz-trust-item">✅ cGMP certified manufacturing</div>
            <div class="mav-quiz-trust-item">📅 53 years of formulation expertise</div>
            <div class="mav-quiz-trust-item">💯 90-day satisfaction guarantee</div>
          </div>
        </div>

        <div class="mav-quiz-disclaimer ${(state.answers.gaps || []).includes('medications') ? 'mav-quiz-disclaimer-bold' : ''}">
          <p>These suggestions are based on your self-reported wellness goals and are not medical advice. They are not intended to diagnose, treat, cure, or prevent any disease. If you take medications or have a medical condition, please consult your healthcare provider.</p>
        </div>
      </div>
    `;

    // Cart functionality
    document.getElementById('mav-add-stack').addEventListener('click', function() {
      const items = primary.map(p => ({ id: getVariantId(p.handle), quantity: 1 }));
      addToCart(items);
      fireKlaviyoEvent('Quiz Product Added', { products: primary.map(p => p.handle), is_bundle: true });
    });

    c.querySelectorAll('.mav-add-single').forEach(btn => {
      btn.addEventListener('click', function() {
        const handle = this.dataset.handle;
        addToCart([{ id: getVariantId(handle), quantity: 1 }]);
        fireKlaviyoEvent('Quiz Product Added', { products: [handle], is_bundle: false });
      });
    });

    // Countdown timer
    startCountdown();
  }

  function renderDisqualification() {
    const c = getContainer();
    const sex = state.answers.sex;
    const multiProduct = sex === 'male' ? "Men's Multi" : "Women's Multi";
    const multiHandle = sex === 'male' ? 'mens-multi' : 'womens-multi';
    const showD = (state.answers.gaps || []).includes('low_sun');

    c.innerHTML = `
      <div class="mav-quiz-results mav-quiz-disqualification">
        <h1>${state.answers.name}, honestly? You're in good shape.</h1>
        <p>Your answers suggest you don't have urgent supplement needs right now. We're not going to push products you don't need — that's not how we operate.</p>
        <p>If anything, a quality daily multivitamin covers your bases:</p>
        <div class="mav-quiz-disq-products">
          <button class="mav-quiz-btn-secondary mav-add-single" data-handle="${multiHandle}">${multiProduct} — Add to Cart</button>
          ${showD ? `<button class="mav-quiz-btn-secondary mav-add-single" data-handle="good-vitamin-d-60-caps">Good Vitamin D 2000 IU — Add to Cart</button>` : ''}
        </div>
        <p class="mav-quiz-disq-footer">Bookmark this page. When your body starts telling you something different, come back and retake the quiz.</p>
      </div>
    `;

    c.querySelectorAll('.mav-add-single').forEach(btn => {
      btn.addEventListener('click', function() {
        addToCart([{ id: getVariantId(this.dataset.handle), quantity: 1 }]);
      });
    });
  }

  // ============================================================
  // HELPERS
  // ============================================================

  function progressBar(step, total) {
    const pct = Math.round((step / total) * 100);
    return `
      <div class="mav-quiz-progress">
        <div class="mav-quiz-progress-bar" style="width: ${pct}%"></div>
      </div>
      <p class="mav-quiz-step-label">Step ${step} of ${total}</p>
    `;
  }

  function getPersonalizedReason(product, answers) {
    // Generate personalized "because you said" copy based on their answers
    const goals = answers.goals || [];
    const reasons = {
      inflameze_advanced: goals.includes('joint_comfort') ? "You said your joints ache more than they used to. This is our high-absorption turmeric + boswellia + bromelain formula." : product.why,
      inflameze_ultra: "You mentioned giving up activities you love. This is our maximum-strength formula for serious joint and muscle support.",
      triple_b12: goals.includes('energy') ? "You said you're exhausted by 2pm. B-12 is the #1 energy vitamin, and our sublingual dots absorb 3x faster than capsules." : product.why,
      adrenal_support: goals.includes('stress_mood') ? "You said stress is eating you alive. Our Adrenal Support formula targets the HPA axis for real stress resilience." : product.why,
      sleepy_sleep: goals.includes('sleep') ? "You said you can't fall asleep. This herbal blend works with your body's natural sleep mechanisms." : product.why,
      melatonin_tr: "You mentioned waking up at 3am. Timed-release melatonin delivers steady support throughout the night.",
      brain_boost: goals.includes('brain_focus') ? "You said brain fog is ruining your productivity. This formula targets multiple cognitive pathways." : product.why,
      yourheart: goals.includes('heart_health') ? "You said you worry about your heart. This is comprehensive cardiovascular and circulation support." : product.why,
      nice_bones: goals.includes('bone_health') ? "You're concerned about bone density. Calcium + magnesium + vitamin D in the forms your bones actually absorb." : product.why,
      five_htp: goals.includes('stress_mood') ? "You mentioned racing thoughts. 5-HTP supports the serotonin pathway — your brain's natural calm-down signal." : product.why,
      quercetin_nettle: goals.includes('immune') ? "You said you catch every cold that goes around. Quercetin + nettle is powerful immune and seasonal support." : product.why,
      super_enzymes: goals.includes('digestive') ? "You said your digestion is a mess. Comprehensive enzymes help break down food properly so you actually absorb nutrients." : product.why,
      nutrisilk: goals.includes('beauty') ? "You're concerned about thinning hair and brittle nails. NutriSilk targets all three — hair, skin, and nails." : product.why,
      nmn_nr: goals.includes('longevity') ? "You want to age on your own terms. NMN + NR are NAD+ precursors that support mitochondrial health at the cellular level." : product.why,
      coq10: goals.includes('heart_health') ? "Heart energy depends on CoQ10 — and your body makes less of it after 40." : product.why,
    };
    return reasons[product.key] || product.why;
  }

  function getVariantId(handle) {
    // This will be populated from Shopify product data
    // For now, return the handle — the Liquid template will inject a lookup map
    return window.__mav_variant_map && window.__mav_variant_map[handle] ? window.__mav_variant_map[handle] : handle;
  }

  function addToCart(items) {
    // Validate all items have numeric variant IDs
    const validItems = items.filter(item => {
      const id = parseInt(item.id);
      if (isNaN(id) || id <= 0) {
        console.warn('Invalid variant ID for item:', item);
        return false;
      }
      return true;
    }).map(item => ({
      id: parseInt(item.id),
      quantity: item.quantity || 1
    }));

    if (validItems.length === 0) {
      alert('Sorry, there was an error adding items to your cart. Please try adding products individually from our shop.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: validItems })
    })
    .then(r => {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(data => {
      // Redirect to cart page
      window.location.href = '/cart';
    })
    .catch(err => {
      console.error('Cart add error:', err);
      alert('There was an error adding to cart. Please try again or shop directly.');
    });
  }

  function startCountdown() {
    const el = document.getElementById('mav-countdown');
    if (!el) return;
    let seconds = 48 * 60 * 60; // 48 hours
    setInterval(function() {
      seconds--;
      if (seconds <= 0) return;
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;
      el.textContent = `${h}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    }, 1000);
  }

  // ============================================================
  // KLAVIYO INTEGRATION
  // ============================================================

  function identifyKlaviyo(email, answers) {
    if (!KLAVIYO_COMPANY_ID) return;
    const properties = {
      $first_name: answers.name,
      quiz_age_range: answers.age,
      quiz_sex: answers.sex,
      quiz_pregnancy_status: answers.pregnancy || null,
      quiz_primary_goals: answers.goals,
      quiz_nutrient_gaps: (answers.gaps || []).filter(g => g !== 'none'),
      quiz_supplement_experience: (answers.gaps || []).includes('beginner') ? 'beginner' : 'experienced',
      quiz_takes_medications: (answers.gaps || []).includes('medications'),
      quiz_completed_at: new Date().toISOString()
    };

    // Add deep-dive answers
    (answers.goals || []).forEach(goal => {
      if (answers['deepdive_' + goal]) {
        properties['quiz_' + goal + '_detail'] = answers['deepdive_' + goal];
      }
    });

    // Add recommended products
    if (state.results) {
      properties.quiz_recommended_products = state.results.primary.map(p => p.handle);
      if (state.results.primary[0]) properties.quiz_primary_product = state.results.primary[0].handle;
      if (state.results.primary[1]) properties.quiz_secondary_product = state.results.primary[1].handle;
      if (state.results.primary[2]) properties.quiz_tertiary_product = state.results.primary[2].handle;
    }

    // Klaviyo identify
    if (window.klaviyo) {
      window.klaviyo.push(['identify', { $email: email, ...properties }]);
    }

    // Also use the Klaviyo Client API directly
    fetch(`https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: {
            email: email,
            first_name: answers.name,
            properties: properties
          }
        }
      })
    }).catch(err => console.log('Klaviyo identify error:', err));
  }

  function fireKlaviyoEvent(eventName, data) {
    if (!KLAVIYO_COMPANY_ID) return;

    const payload = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: eventName } } },
          properties: data,
          profile: { data: { type: 'profile', attributes: {} } }
        }
      }
    };

    // Add email if available
    if (state.answers.email) {
      payload.data.attributes.profile.data.attributes.email = state.answers.email;
    }

    fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify(payload)
    }).catch(err => console.log('Klaviyo event error:', err));

    // Also push to klaviyo.js if loaded
    if (window.klaviyo) {
      window.klaviyo.push(['track', eventName, data]);
    }
  }

  function buildEventPayload() {
    const answers = state.answers;
    const results = state.results;
    return {
      name: answers.name,
      email: answers.email,
      age_range: answers.age,
      sex: answers.sex,
      pregnancy_status: answers.pregnancy,
      primary_goals: answers.goals,
      nutrient_gaps: answers.gaps,
      recommended_products: results ? results.primary.map(p => ({ name: p.name, handle: p.handle, price: p.price })) : [],
      secondary_products: results ? results.secondary.map(p => ({ name: p.name, handle: p.handle, price: p.price })) : [],
      quiz_url: window.location.href,
      completed_at: new Date().toISOString()
    };
  }

  function requestDiscountCode(email) {
    const el = document.getElementById('mav-discount-code');
    if (el) el.textContent = 'BLUEPRINT15'; // Show default while loading
    fetch(DISCOUNT_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
    .then(r => r.json())
    .then(data => {
      if (data.code && el) {
        el.textContent = data.code;
        state.discountCode = data.code;
        // Fire Klaviyo event for discount generation
        fireKlaviyoEvent('Quiz Discount Generated', {
          discount_code: data.code,
          email: email,
          expires_at: data.expires_at || null
        });
      }
    })
    .catch(err => {
      console.log('Discount code error:', err);
      // Keep showing BLUEPRINT15 as fallback
    });
  }


  // ============================================================
  // SUPABASE RESPONSE LOGGING
  // ============================================================
  function logQuizResponse() {
    const answers = state.answers;
    const results = state.results;
    const payload = {
      email: answers.email || null,
      name: answers.name || null,
      age_range: answers.age || null,
      sex: answers.sex || null,
      pregnancy_status: answers.pregnancy || null,
      primary_goals: answers.goals || [],
      nutrient_gaps: answers.gaps || [],
      deep_dive_answers: {},
      recommended_products: results ? results.primary.map(p => ({ name: p.name, handle: p.handle, price: p.price })) : [],
      secondary_products: results ? results.secondary.map(p => ({ name: p.name, handle: p.handle, price: p.price })) : [],
      discount_code: state.discountCode || 'BLUEPRINT15',
      completed_at: new Date().toISOString(),
      user_agent: navigator.userAgent,
      referrer: document.referrer || null
    };
    // Add deep-dive answers
    (answers.goals || []).forEach(goal => {
      if (answers['deepdive_' + goal]) {
        payload.deep_dive_answers[goal] = answers['deepdive_' + goal];
      }
    });
    // Send to our API endpoint for Supabase logging
    fetch('https://api.highlandlabs.life/subscription-delay/quiz-response', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(err => console.log('Quiz response log error:', err));
  }
  // ============================================================
  // INITIALIZATION
  // ============================================================
  function init() {
    const container = document.getElementById('mav-wellness-quiz');
    if (!container) return;
    render();
  }

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
